export const MEMBERS_V2_TESTERS_CONFIG = {
  emails: [
    'ismaelmncosta@gmail.com',
    'gabrielalves@cakto.com.br',
    'ulisses@hevex.app',
    'contato@cakto.com.br',
    'matheus.moreiracosta300@gmail.com',
    'jeefjr@icloud.com'
  ]
};

export const isUserMembersV2Tester = (user) => {
  if (!user) return false;

  const { emails } = MEMBERS_V2_TESTERS_CONFIG;

  return user.email && emails.includes(String(user.email));
};


export const canUserAccessMembersV2 = (user) => {
  if (!user) return false;

  if (typeof user !== 'object') return false;

  return Boolean(user.is_producer);
};

export const generateMembersV2Url = (productId, productName) => {
  const base = process.env.REACT_APP_MEMBERS_V2_BASE_URL || 'https://aluno.cakto.com.br';

  if (!productId) {
    console.error('generateMembersV2Url: productId is required');
    return base;
  }

  const encodedProductName = encodeURIComponent(productName || 'Produto sem nome');

  return `${base}/app/admin/courses/create?caktoProductId=${productId}&caktoProductName=${encodedProductName}`;
};
